import type { OrthographicCamera, PerspectiveCamera } from "three"
import getSetEngineWeakMapFactory from "./getSetEngineWeakMapFactory"

type EngineThreeMainCamera = PerspectiveCamera | OrthographicCamera

export const [getEngineThreeMainCamera, setEngineThreeMainCamera] = getSetEngineWeakMapFactory<EngineThreeMainCamera>()
